// extracted by mini-css-extract-plugin
export default {"form":"List_form__VAk0J","input":"List_input__RY0uP","plusIcon":"List_plusIcon__pCseC"};